<script setup>

import CloseButton from '../components/CloseButton.vue'
import NavButton from '../components/NavButton.vue'
import FieldsTableRow from '../components/FieldsTableRow.vue'
import SavingCalcState from '../components/calculations/SavingCalcState.vue'
import SavingCalcPersonal from '../components/calculations/SavingCalcPersonal.vue'
import SavingCalcDc from '../components/calculations/SavingCalcDc.vue'
import SavingCalcDb from '../components/calculations/SavingCalcDb.vue'
import SavingCalcOther from '../components/calculations/SavingCalcOther.vue'
import {computed, ref, watch} from "vue";
import { store } from "@/store";

const calculating = computed(() => {
  return store.formState.awaitingSavingCalc
})
const savingTypeLabel = computed(() => {
  return savingTypes.value.filter(type => type.slug === savingType.value)[0].label
})
const savingType = ref(store.formState.addSavingType)
watch( savingType, () => {
      saving.value = JSON.parse(JSON.stringify(blankSaving.value))
    } // Reset saving data when type changes
)
const requestSaving = () => {
  store.formState.awaitingSavingCalc = true;
}
const addSaving = () => {
  store.formState.awaitingSavingCalc = false;
  store.formData.savings[savingType.value].parts.push(saving.value);
  store.formData.savings[savingType.value].totalAnnual = saving.value.valueAnnual;
  store.formData.savings[savingType.value].totalWeekly = saving.value.valueWeekly;
  store.formState.addSavingType = '';
  store.formState.modal = false;
}

const saving = ref({
      valueAnnual: 0,
      valueWeekly: 0,
      valid: false
    }
)
const blankSaving = ref({
  valueAnnual: 0,
  valueWeekly: 0,
  valid: false
})
const savingValue = ref(0)
const savingTypes = ref([
  {label: 'State Pension', slug: 'state'},
  {label: 'Your PSPS Personal Account', slug: 'personal'},
  {label: 'Other Defined Contribution (DC) retirement savings', slug: 'dc'},
  {label: 'Other Defined Benefit (DB) retirement savings', slug: 'db'},
  {label: 'Other sources of income at retirement', slug: 'other'},
])

</script>

<template>
  <div class="modal-2609 modal__sra">
    <div class="m__content">
      <CloseButton v-on:click="store.resetSavingType(); store.closeModal()">Close</CloseButton>

      <div class="fields-table">
        <table>
          <tbody>
          <FieldsTableRow v-bind:label="'Type of savings'">
            <span class="ft__fake-input">{{ savingTypeLabel }}</span>
            <!-- <v-select v-model="savingType" :options="savingTypes" :reduce="savingType => savingType.slug" :disabled="calculating" /> -->
          </FieldsTableRow>
          </tbody>
        </table>
      </div>
      <div class="fields-table">
        <table>
          <tbody>

          <!-- State saving calculator -->
          <SavingCalcState v-if="savingType === 'state'"
                           :saving="saving"
                           :calculating="calculating"
                           :disabled="calculating" @calcDone="addSaving"/>

          <!-- Personal saving calculator -->
          <SavingCalcPersonal v-if="savingType === 'personal'"
                              :saving="saving"
                              :calculating="calculating"
                              :disabled="calculating" @calcDone="addSaving"/>

          <!-- DC saving calculator -->
          <SavingCalcDc v-if="savingType === 'dc'"
                        :saving="saving"
                        :calculating="calculating"
                        :disabled="calculating"
                        @calcDone="addSaving"/>

          <!-- DB saving calculator -->
          <SavingCalcDb v-if="savingType === 'db'"
                        :saving="saving"
                        :calculating="calculating"
                        :disabled="calculating"
                        @calcDone="addSaving"/>

          <!-- Other saving calculator -->
          <SavingCalcOther v-if="savingType === 'other'"
                           :saving="saving"
                           :calculating="calculating"
                           :disabled="calculating" @calcDone="addSaving"/>

          </tbody>
        </table>
      </div>

      <div class="nav-bar">
        <NavButton dir=">" class="no-pn" v-on:click="requestSaving" v-bind:disabled="!saving.valid || calculating">Add
        </NavButton>
      </div>
    </div>
  </div>
</template>
